// Setting up Mixpanel
import mixpanel from 'mixpanel-browser';

// Lib

/* Init */
// Debug mode
const debug = process.env.NODE_ENV === 'development';
mixpanel.init('f44efcb384ec9b618a7911c699a7f025', { debug: debug });

export const analyzer = {
  register: async (id, { username, is_admin, sub_username, msp_id }) => {
    if (sub_username) {
      mixpanel.identify(id + '-' + sub_username);
    } else {
      mixpanel.identify(id);
    }
    let ss = sub_username ? username + '-' + sub_username : username;
    mixpanel.people.set({
      $name: ss,
      IsAdmin: is_admin,
      MspId: msp_id,
      SubUsername: sub_username,
    });

    return Promise.resolve();
  },

  // register: async (
  //   id,
  //   {
  //     username,
  //     is_admin,
  //   }
  // ) => {
  //   mixpanel.identify(id);

  //   mixpanel.people.set({
  //     $name: username,
  //     $email: emailMask(email),
  //     "Is Admin": is_admin,
  //     SSO: sso_enabled,
  //     MFA: mfa_enabled,
  //     Locale: locale,
  //     Theme: app_theme,
  //     "Favorite views count": favorite_views.length,
  //     Avatar: !!avatar,
  //   });

  /**
   * Tracking event
   * @param {String} event_name - The name of the event. This can be anything the user does.
   *                              'Button Click', 'Sign Up', etc.
   * @param {object} [properties] - A set of properties to include with the event you're sending.
   *                                These describe the user who did the event or details about the event itself.
   * @param {object} [options] - Optional configuration for this track request.
   * @return {Promise<unknown>}
   */
  track: async (event_name, properties = undefined, options = undefined) => {
    const res = mixpanel.track(event_name, properties, options);
    return Promise.resolve(res);
  },
  time_event: async event_name => {
    const res = mixpanel.time_event(event_name);
    return Promise.resolve(res);
  },
  deleteUser: async () => {
    mixpanel.people.delete_user();
  },
  setIdentify(id) {
    mixpanel.identify(id);
  },
  updateProperty: async (key, value) => {
    mixpanel.people.set(key, value);
  },
  reset: async () => {
    mixpanel.reset();
    return Promise.resolve();
  },
};
